import { render, staticRenderFns } from "./HomeViewPeople.vue?vue&type=template&id=0ebbd7be&scoped=true&"
import script from "./HomeViewPeople.vue?vue&type=script&lang=js&"
export * from "./HomeViewPeople.vue?vue&type=script&lang=js&"
import style0 from "./HomeViewPeople.vue?vue&type=style&index=0&id=0ebbd7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebbd7be",
  null
  
)

export default component.exports